import React, { FC } from "react";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";
import { MastercardCardIcon } from "./Icons/Mastercard/Mastercard";
import { CartesBancairesCardIcon } from "./Icons/CartesBancaires/CartesBancaires";
import { AmericanExpressCardIcon } from "./Icons/AmericanExpress/AmericanExpress";
import { VisaCardIcon } from "./Icons/Visa/Visa";
import { HStack } from "@UI/Components/Stack/Stack";
import { BancontactCardIcon } from "./Icons/Bancontact/Bancontact";
import { useCurrentUser } from "@modules/Authentication/hooks/useCurrentUser";

interface Props {
  paymentMethod: PaymentMethodType;
}

export const PaymentMethodIcons: FC<Props> = ({ paymentMethod }) => {
  const { currentUser } = useCurrentUser();

  const isUserFrench = currentUser?.countryId === 2;

  if (paymentMethod === PaymentMethodType.CREDIT_CARD) {
    return (
      <HStack spacing="5px">
        <MastercardCardIcon />
        {isUserFrench && <CartesBancairesCardIcon />}
        {!isUserFrench && <AmericanExpressCardIcon />}
        <VisaCardIcon />
      </HStack>
    );
  } else if (paymentMethod === PaymentMethodType.BANCONTACT) {
    return <BancontactCardIcon />;
  } else {
    return <></>;
  }
};
